import { Component, OnInit, ElementRef, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

import * as d3 from 'd3';
import 'd3-scale-chromatic';
import { ChangeDetectorRef } from '@angular/core';

interface ChartData {
  machineName: string;
  parameterName: string;
  parameterCoefficientValue: number;
}

@Component({
    selector: 'app-d3-ci-sunburn',
    templateUrl: './d3-ci-sunburn.component.html',
    styleUrls: ['./d3-ci-sunburn.component.scss'],
    standalone: false
})
export class D3CiSunburnComponent implements OnInit, OnChanges {
  @Input() data: ChartData[] = [];

  // private data = [
  //   { "machineName": "TQ 1206 - Mistura Ácida", "parameterName": "WT1206 - Massa do Tanque 1206", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Fluidbed 02", "parameterName": "FB02 - Dosagem de Zeolito", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Fluidbed 01", "parameterName": "FB01 - Dosagem de Pre Mistura", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Fluidbed 01", "parameterName": "FB01 - Dosagem de Zeolito", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "TQ 1206 - Mistura Ácida", "parameterName": "TT1206A - Temperatura Tanque 1206", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Fluidbed 02", "parameterName": "FB02 - Dosagem de Pre Mistura", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Perfumador 1500", "parameterName": "DF1504 - Dosagem de Speckles", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Fluidbed 02", "parameterName": "FB02 - Dosagem de Mistura Acida", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Perfumador 1500", "parameterName": "T1511 - Dosagem de Perfume", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Nerak", "parameterName": "Balança 2 Nerak - Peso", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Nerak", "parameterName": "Balança 1 Nerak - Peso", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "HAPMAN", "parameterName": "Vazão entrada Hapman", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "HAPMAN", "parameterName": "Corrente Hapman", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "HAPMAN", "parameterName": "Frequência Hapman", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "TQ 1205 - Mistura Acida", "parameterName": "TT1205A - Temperatura do Tanque 1205", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "TQ 1205 - Mistura Acida", "parameterName": "WT1205 - Massa Tanque 1205", "parameterCoefficientValue": 0.892 },
  //   { "machineName": "Fluidbed 01", "parameterName": "FB01 - Dosagem de Mistura Acida", "parameterCoefficientValue": 0.092 },
  //   { "machineName": "Plougshared 1216", "parameterName": "Plougshared1216 - Dosagem de Barrilha", "parameterCoefficientValue": 0.092 }
  // ];


  // private data: ChartData[] = [
  //   { machineName: "Machine 1", parameterName: "Meter 1", parameterCoefficientValue: 60 },
  //   { machineName: "Machine 1", parameterName: "Meter 2", parameterCoefficientValue: 50 },
  //   { machineName: "Machine 1", parameterName: "Meter 3", parameterCoefficientValue: 40 },
  //   { machineName: "Machine 1", parameterName: "Meter 6", parameterCoefficientValue: 30 },
  //   { machineName: "Machine 1", parameterName: "Meter 7 Meter 7", parameterCoefficientValue: 90 },
  //   { machineName: "Machine 1", parameterName: "Meter 9 Meter 7", parameterCoefficientValue: 90 },
  //   { machineName: "Machine 2", parameterName: "Meter 14", parameterCoefficientValue: 10 },
  //   { machineName: "Machine 2", parameterName: "Meter 15", parameterCoefficientValue: 15 },
  //   { machineName: "Machine 2", parameterName: "Meter 16 3Meter 3Meter", parameterCoefficientValue: 25 },
  //   { machineName: "Machine 2", parameterName: "Meter 17 4Meter 4Meter", parameterCoefficientValue: 35 },
  //   { machineName: "Machine 3", parameterName: "Meter 18", parameterCoefficientValue: 10 },
  //   { machineName: "Machine 3", parameterName: "Meter 19", parameterCoefficientValue: 15 },
  //   { machineName: "Machine 3", parameterName: "Meter 20", parameterCoefficientValue: 25 },
  //   { machineName: "Machine 3", parameterName: "Meter 21", parameterCoefficientValue: 35 },
  //   { machineName: "Machine 4", parameterName: "Meter 22 Meter", parameterCoefficientValue: 80 },
  //   { machineName: "Machine 4", parameterName: "Meter 23", parameterCoefficientValue: 15 },
  //   { machineName: "Machine 4", parameterName: "Meter 24", parameterCoefficientValue: 25 },
  //   { machineName: "Machine 4", parameterName: "Meter 25 Meter 25", parameterCoefficientValue: 90 },
  //   { machineName: "Machine 5", parameterName: "Meter 26", parameterCoefficientValue: 80 },
  //   { machineName: "Machine 5", parameterName: "Meter 27", parameterCoefficientValue: 15 },
  //   { machineName: "Machine 5", parameterName: "Meter 28", parameterCoefficientValue: 25 },
  //   { machineName: "Machine 5", parameterName: "Meter 29 Meter 29", parameterCoefficientValue: 90 }
  // ];

  // private colorPalette: string[] = [
  //   '#f77b7b', // red
  //   '#8bc34a', // green
  //   '#4fc3f7', // blue
  //   '#b60ddc', // purple
  //   '#ffb300', // orange (add more if needed)
  //   '#4000d4ff', // cyan
  //   '#e91e63', // pink
  //   '#607d8b', // blue-grey
  //   '#363531ff'  // yellow
  // ];
  // different color scheme schemeCategory10 , schemePaired , schemeDark2 , schemeSet1
  private colorPalette: string[] = [...d3.schemeCategory10, ...d3.schemeSet2, ...d3.schemeSet3];

  private groupMachineColors: Record<string, string> = {};
  private groupmachines: Record<string, string> = {};
  private selectedGroups: Set<string> = new Set(Object.keys(this.groupMachineColors)); // All selected by default

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data && this.data.length > 0) {
      this.prepareAndDrawChart();
    }
  }

  private prepareAndDrawChart(): void {
    // Get unique machine names
    const uniqueMachines = Array.from(new Set(this.data.map(d => d.machineName)));
    // Generate mapping: { "Machine 1": "M1", ... }
    this.groupmachines = uniqueMachines.reduce(
      (acc: Record<string, string>, name, idx) => {
        acc[name] = `M${idx + 1}`;
        return acc;
      },
      {} as Record<string, string>
    );

    this.groupMachineColors = uniqueMachines.reduce(
      (acc: Record<string, string>, name, idx) => {
        acc[name] = this.colorPalette[idx % this.colorPalette.length];
        return acc;
      },
      {} as Record<string, string>
    );
    this.selectedGroups = new Set(Object.keys(this.groupMachineColors));

    // Sort by machineName to group arcs by machine
    this.data.sort((a, b) => {
      if (a.machineName === b.machineName) {
        return a.parameterName.localeCompare(b.parameterName);
      }
      return a.machineName.localeCompare(b.machineName);
    });

    this.createChart();
  }

  @HostListener('window:resize')
  onResize() {
    d3.select(this.el.nativeElement.querySelector('#circular-bar-chart')).selectAll('*').remove();
    this.createChart();
  }

  private createChart(): void {
    const container = this.el.nativeElement.querySelector('#circular-bar-chart');
    d3.select(container).selectAll('*').remove(); // Clear previous chart

    const containerWidth = container.offsetWidth;
    const width = containerWidth;
    const height = containerWidth;
    const innerRadius = width / 7;
    const outerRadius = width / 3;
    const margin = 2;

    // --- Legend with click handlers ---
    const legend = d3.select(container)
      .append('div')
      .attr('class', 'legend')
      .style('display', 'flex')
      .style('flex-wrap', 'wrap')
      .style('justify-content', 'center')
      .style('gap', '3px')
      .style('margin-bottom', '-3px')
      .style('max-width', '100%');

    Object.entries(this.groupMachineColors).forEach(([machineName, color]) => {
      const legendItem = legend.append('div')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('gap', '4px')
        .style('cursor', 'pointer')
        .style('opacity', this.selectedGroups.has(machineName) ? '1' : '0.4')
        .on('click', () => {
          if (this.selectedGroups.has(machineName)) {
            this.selectedGroups.delete(machineName);
          } else {
            this.selectedGroups.add(machineName);
          }
          this.createChart(); // Redraw chart with new selection
        });

      legendItem.append('div')
        .style('width', '12px')
        .style('height', '12px')
        .style('background', color)
        .style('border-radius', '2px')
        .style('border', this.selectedGroups.has(machineName) ? '1px solid #222' : '1px solid #ccc');

      legendItem.append('span')
        .style('font-size', '12px')
        .text(machineName);
    });

    // --- Filter data based on selected groups ---
    const filteredData = this.data.filter(d => this.selectedGroups.has(d.machineName));
    if (filteredData.length === 0) return; // Don't draw chart if nothing selected

    const svg = d3.select(container)
      .append('svg')
      .attr('width', width + margin * 2)
      .attr('height', height + margin * 2)
      .append('g')
      .attr('transform', `translate(${(width + margin * 2) / 2}, ${(height + margin * 2) / 2})`);


    const gapAngle = Math.PI / 6;
    const startAngle = gapAngle / 2;
    const endAngle = 2 * Math.PI - gapAngle / 2;

    const angle = d3.scaleBand()
      .domain(filteredData.map(d => d.parameterName))
      .range([startAngle, endAngle]);

    const minValue = d3.min(filteredData, d => d.parameterCoefficientValue)!;
    const maxValue = d3.max(filteredData, d => d.parameterCoefficientValue)!;
    const hasNegative = minValue < 0;
    const absMax = Math.max(Math.abs(minValue), Math.abs(maxValue));

    const innerRadius1 = width / 7;
    const outerRadius1 = width / 3;
    const middleRadius = (innerRadius1 + outerRadius1) / 2;

    // If negative values exist, use symmetric scale
    const radius = hasNegative
      ? d3.scaleLinear()
        .domain([minValue, 0, maxValue])
        .range([innerRadius1, middleRadius, outerRadius1])
      : d3.scaleLinear()
        .domain([0, maxValue])
        .range([innerRadius1, outerRadius1]); // <-- No middle, fill full space



    const arcGenerator = d3.arc();

    // All bars start at outerRadius (baseline) and extend inward
    const processedData = filteredData.map(d => ({
      ...d,
      startAngle: angle(d.parameterName)!,
      endAngle: angle(d.parameterName)! + angle.bandwidth(),
      innerRadius: radius(0),
      outerRadius: radius(d.parameterCoefficientValue),
      padAngle: 0.01,
      padRadius: innerRadius1
    }));

    svg.append('g')
      .selectAll('path')
      .data(processedData)
      .enter()
      .append('path')
      .attr('fill', d => this.groupMachineColors[d.machineName])
      .attr('d', d => arcGenerator(d as any)!);

    // Tick circles (dotted lines) from outer to inner
    let tickValues: number[];
    if (hasNegative) {
      const numTicks = 4;
      tickValues = d3.range(minValue, maxValue + (maxValue - minValue) / numTicks, (maxValue - minValue) / numTicks);
    } else {
      const numTicks = 4;
      tickValues = d3.range(0, maxValue + maxValue / numTicks, maxValue / numTicks);
    }

    svg.append('g')
      .selectAll('circle')
      .data(tickValues)
      .enter()
      .append('circle')
      .attr('r', d => radius(d))
      .attr('fill', 'none')
      .attr('stroke', '#bbb')
      .attr('stroke-dasharray', '2,2');

    svg.append('g')
      .selectAll('text')
      .data(tickValues)
      .enter()
      .append('text')
      .attr('y', d => -radius(d))
      .attr('x', 0)
      .attr('dy', '-4')
      .attr('text-anchor', 'middle')
      .style('font-size', '10px')
      .style('fill', '#888')
      .text(d => d.toFixed(3));


    // Group labels
    const groups = Array.from(new Set(filteredData.map(d => d.machineName)));
    const groupLabels = groups.map(machineName => {
      const items = filteredData.filter(d => d.machineName === machineName);
      const angles = items.map(d => angle(d.parameterName)! + angle.bandwidth() / 2);
      const avgAngle = d3.mean(angles)!;
      return {
        parameterName: this.groupmachines[machineName],
        fullName: machineName,
        angle: avgAngle
      };
    });

    const labelRadius = innerRadius - 12;

    svg.append('g')
      .selectAll('text.machineName-label')
      .data(groupLabels)
      .enter()
      .append('text')
      .attr('class', 'machineName-label')
      .attr('x', d => Math.cos(d.angle - Math.PI / 2) * labelRadius)
      .attr('y', d => Math.sin(d.angle - Math.PI / 2) * labelRadius)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'middle')
      .style('font-size', '14px')
      .style('font-weight', 'bold')
      .style('fill', d => this.groupMachineColors[d.fullName])
      .text(d => d.parameterName)
      .append('title')
      .text(d => d.fullName);

    // svg.append('g')
    //   .selectAll('text.machineName-label')
    //   .data(groupLabels)
    //   .enter()
    //   .append('text')
    //   .attr('class', 'machineName-label')
    //   .attr('x', d => Math.cos(d.angle - Math.PI / 2) * labelRadius)
    //   .attr('y', d => Math.sin(d.angle - Math.PI / 2) * labelRadius)
    //   .attr('transform', d => `rotate(${(d.angle * 180 / Math.PI - 90)},${Math.cos(d.angle - Math.PI / 2) * labelRadius},${Math.sin(d.angle - Math.PI / 2) * labelRadius})`)
    //   .attr('text-anchor', 'middle')
    //   .attr('alignment-baseline', 'middle')
    //   .style('font-size', '14px')
    //   .style('font-weight', 'bold')
    //   .style('fill', d => this.groupMachineColors[d.fullName])
    //   .text(d => d.parameterName)
    //   .append('title')
    //   .text(d => d.fullName);

    // Bar labels
    svg.append('g')
      .selectAll('g')
      .data(processedData)
      .enter()
      .append('g')
      .attr('text-anchor', d => (d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end')
      .attr('transform', d => {
        // For negative bars, label after the bar (closer to center)
        // For positive bars, label after the bar (further from center)
        const angleDeg = ((d.startAngle + d.endAngle) / 2 * 180 / Math.PI - 90);
        const labelRadius = d.parameterCoefficientValue < 0
          ? d.innerRadius + 3 // move label inside for negative
          : d.outerRadius + 10; // move label outside for positive
        return `rotate(${angleDeg}) translate(${labelRadius},0)`;
      })
      .append('text')
      .text(d => d.parameterName.length > 10 ? d.parameterName.slice(0, 10) + '..' : d.parameterName)
      .attr('transform', d => (d.startAngle + d.endAngle) / 2 < Math.PI ? null : 'rotate(180)')
      .attr('alignment-baseline', 'middle')
      .style('font-size', '11px')
      .style('fill', '#444')
      .append('title')
      .text(d => `${d.parameterName}\nCorrelation: ${d.parameterCoefficientValue}`);

  }
}